module.exports = __webpack_public_path__ + "static/awareness_notebook-eb5062e65f0ff14fd4d9cffe32fd8973.svg";